<template>
  <div>
        <h2>Skin/Extremities</h2>
    <v-container v-if="!loading" class="py-10">
        <v-row>
            <v-col v-for="item in skin" class="shrink my-0 py-0" cols="12" md="4" :key="item.id">
                <v-checkbox
                        v-model="skinCheckbox"
                        :disabled="disableSkin(item.id, item.is_normal)"
                        :label='item.name'
                        :value="item.id"
                        hide-details
                        @change="toggle => skinTick(item.id, toggle, item.is_normal)"
                />
            </v-col>
        </v-row>
        <v-row v-if="isSkinRemark">
            <v-col>
                <v-text-field
                        placeholder="Other"
                        outlined
                        v-model="skin_remark"
                        :rules="[v => !!v || 'Skin Other is required']"
                        label="Skin Other"
                        @keyup="includeSkinRemark"
                        required
                />
            </v-col>
        </v-row>
    </v-container>

    <v-container v-else style="text-align: center;">
      <v-progress-circular
        :size="150"
        color="primary"
        indeterminate
        style="text-align: center"
      >Loading Data
      </v-progress-circular>
    </v-container>

  </div>
</template>

<script>
    export default {
        name: "Skin",

        props: {
            formData: {
                type: Object,
                required: true,
            },
            config: Number
        },

        data() {
            return {
                isSkinRemark: false,
                skin_remark: null,
                isSkinNormal: false,
                skin: {},
                skinCheckbox: [],
                loading: true,
            }
        },

        methods: {
            editFieldSkin() {
                let vm = this;
                _.forEach(this.formData.physical_examination.skin, function(value) {
                    vm.skinCheckbox.push(Number.parseInt(value.skin_id));
                    if (value.skin_remark) {
                        vm.skin_remark = value.skin_remark;
                        vm.isSkinRemark = true;
                    }
                });
            },

            disableSkin(id, normal = 0, toggle = true) {
                let vm = this;
                _.forEach(this.formData.physical_examination.skin, function (value) {
                    if (Number.parseInt(value.skin_id) === Number.parseInt(id) && normal && toggle) {
                        vm.isSkinNormal = true;
                    }
                });
                return this.skinCheckbox.indexOf(id) === -1 && this.isSkinNormal;
            },

            skinTick(key, toggle, is_normal) {
                let toggled = toggle.includes(key);
                let skin = this.formData.physical_examination.skin;

                if (key === this.config) {
                    this.isSkinRemark = !this.isSkinRemark;
                }
                if (is_normal) {
                    this.isSkinNormal = !this.isSkinNormal;
                    this.skinNormalOnly(key, toggled);
                    this.disableSkin(key, is_normal, toggled);
                }

                if (toggled) {
                    skin.push({
                        skin_id: key,
                        skin_remark: null,
                    });
                } else {
                    let index = skin.findIndex(skin => skin.skin_id === key);
                    skin.splice(index, 1);
                }
            },

            skinNormalOnly(key, toggled) {
                if (toggled){
                    let skin = this.formData.physical_examination.skin;
                    skin.push({
                        skin_id: key,
                        skin_remark: null,
                    });
                    this.skinCheckbox = [key];
                    skin.splice(0, skin.length);
                    this.isSkinRemark = false;
                }
            },

            includeSkinRemark() {
                let skin = this.formData.physical_examination.skin;
                let index = skin.findIndex(skin => skin.skin_id === this.config);
                skin.splice(index, 1);
                skin.push({
                    skin_id: this.config,
                    skin_remark: this.skin_remark,
                });
            },

            getSkinLib() {
                this.axios.get('skin-lib', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    // handle success
                    this.skin = response.data;
                    this.loading = false;
                }).catch((error) => {
                    // handle error
                }).finally(() => {

                    // always executed
                });
            },
        },

        mounted() {
            this.getSkinLib();
            this.editFieldSkin();
        }
    }
</script>

<style scoped>

</style>